export const hasKlarna = (region: string) => {
  const klarnaRegions = ["de", "nl", "gb"]

  return klarnaRegions.includes(region)
}
